import { useCallback, useMemo, useState } from "react";

export function useRowSelection() {
  const [selectedIds, setSelectedIds] = useState(() => new Set());

  const toggle = useCallback((rowId) => {
    setSelectedIds((current) => {
      const next = new Set(current);
      if (next.has(rowId)) next.delete(rowId);
      else next.add(rowId);
      return next;
    });
  }, []);

  const setAll = useCallback((rowIds, selected) => {
    setSelectedIds(() => (selected ? new Set(rowIds) : new Set()));
  }, []);

  const clear = useCallback(() => setSelectedIds(new Set()), []);

  const syncTo = useCallback((rowIds) => {
    const allowed = new Set(rowIds);
    setSelectedIds((current) => {
      const next = new Set([...current].filter((id) => allowed.has(id)));
      return next.size === current.size ? current : next;
    });
  }, []);

  const selectedArray = useMemo(() => [...selectedIds], [selectedIds]);

  return {
    selectedIds,
    selectedArray,
    selectedCount: selectedIds.size,
    toggle,
    setAll,
    clear,
    syncTo,
  };
}
